module.exports = __webpack_public_path__ + "ck.svg?e08434056c666975c5d972273bbe9ae0";